import React from "react";

/**
 * Fallback UI shown while a lazy-loaded dashboard page is loading.
 * Keeps layout stable and avoids flash of empty content.
 */
function DashboardPageFallback() {
  return (
    <div
      className="flex items-center justify-center min-h-full bg-[rgb(244,247,255)]"
      role="status"
      aria-label="Loading"
      style={{ height: "100vh" }}
    >
      <div className="animate-pulse flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-2 border-[rgb(67,25,255)] border-t-transparent rounded-full animate-spin" />
        <span className="text-sm text-[#4B465C]">Loading...</span>
      </div>
    </div>
  );
}

export default DashboardPageFallback;
